import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { PlusIcon, MinusIcon } from 'sharedComponents/Icons';
import cx from 'classnames';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';

export const Tree = ({
  treeData,
  classes,
  labelRenderer,
  loading,
  onNodeToggle,
  expandedNodesMap,
  noTopLevelPadding,
}) => {
  const renderTreeItem = (node, topLevel) => (
    <TreeItem
      key={node.id}
      nodeId={node.id}
      label={labelRenderer(node)}
      data-testid={`tree-item-${node.id}`}
      classes={{
        iconContainer: cx(classes.iconContainer, !node.children?.length && classes.hideBox),
        label: cx(
          classes.label,
          !node.children?.length && classes.noPadding,
          !node.children?.length && topLevel && classes.topLevelPadding,
        ),
        group: classes.group,
        content: classes.content,
      }}
      onIconClick={(event) => {
        if (loading) {
          // prevent expand node on icon click
          event.preventDefault();
        }
      }}
      onLabelClick={(event) => {
        // prevent expand node on label click
        event.preventDefault();
      }}
    >
      {Array.isArray(node.children) ? node.children.map((childNode) => renderTreeItem(childNode)) : null}
    </TreeItem>
  );

  const getDefaultExpandedNodeIds = (id) => _get(expandedNodesMap, id, []);
  const topLevelNode = !noTopLevelPadding;

  return (
    <TreeView
      defaultCollapseIcon={<MinusIcon className={classes.toggleIcon} />}
      defaultExpandIcon={<PlusIcon className={classes.toggleIcon} />}
      defaultExpanded={getDefaultExpandedNodeIds(treeData.id)}
      onNodeToggle={(event, expandedNodeIds) => onNodeToggle(event, expandedNodeIds, treeData.id)}
      className={classes.tree}
      // This line is necessary to pass an object of classes for the MUI 4 version of this component
      classes={{}}
    >
      {renderTreeItem(treeData, topLevelNode)}
    </TreeView>
  );
};

Tree.propTypes = {
  treeData: PropTypes.shape({}),
  labelRenderer: PropTypes.func,
  expandedNodesMap: PropTypes.shape({}),
  noTopLevelPadding: PropTypes.bool,
};

Tree.defaultProps = {
  labelRenderer: () => {},
  treeData: {},
  expandedNodesMap: {},
  noTopLevelPadding: false,
};

export default Tree;
